<div class="tr layout-row layout-align-start-center">

  <!--Provider's Name-->
  <div class="td col-name text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 text-ellipsis">{{ provider.name }}</span>
  </div>

  <!--Description-->
  <div class="td col-description text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 gray-103 text-ellipsis"
          [ngbTooltip]="provider.description"
          openDelay="300"
          triggers="hover"
          container="body">
      {{ provider.description || '-' }}
    </span>
  </div>

  <!--Type-->
  <div class="td col-type layout-row layout-align-start-center">
    <span class="provider-type-tag br-caption-2"
          [class.prediction]="isPrediction"
          [class.projection]="!isPrediction">
      {{ typeLabelKey | translate }}
    </span>
  </div>

  <!--Resolver-->
  <div class="td col-resolver text-ellipsis layout-row layout-align-start-center">
    <span class="br-body-2 gray-103 text-ellipsis"
          [ngbTooltip]="resolverSummary"
          openDelay="300"
          triggers="hover"
          container="body">
      {{ resolverSummary }}
    </span>
  </div>

  <!--Active - saved as the provider's `active` through the update endpoint. Archiving is a
      separate action, in the row's menu.-->
  <div class="td col-active layout-row layout-align-start-center">
    <bringoz-switch *ngxPermissionsOnly="'settings.update'"
                    [checked]="isActive"
                    [classSize]="'sm'"
                    name="site-provider-active-{{provider.id}}"
                    (onChange)="onActiveChange.emit($event)">
    </bringoz-switch>
  </div>

  <!--Actions-->
  <div class="td col-actions layout-row layout-align-center-center">
    <app-site-provider-action-menu [providerId]="provider.id"
                                   (onEdit)="onEdit.emit()"
                                   (onArchive)="onArchive.emit()">
    </app-site-provider-action-menu>
  </div>

</div>
